const messages = {
    deleted: "Message deleted.",
}
export default messages;